import React from 'react';
import { useLanguageStore } from '../store';

export const PrivacyPage = () => {
  const { language } = useLanguageStore();

  return (
    <div className="container-custom py-16 text-left max-w-4xl select-text">
      {/* РУССКИЙ ЯЗЫК */}
      {language === 'ru' && (
        <article className="prose dark:prose-invert max-w-none space-y-6">
          <h1 className="text-3xl font-light uppercase tracking-tight">ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ</h1>
          <p className="text-sm text-muted-foreground">Последнее обновление: 12 августа 2026 г.</p>

          <section className="space-y-3">
            <h2 className="text-xl font-medium">1. Кто мы</h2>
            <p>
              Коммерческая деятельность осуществляется индивидуальным предпринимателем <strong>Oksana Fedyk</strong> под коммерческим наименованием <strong>FEDYK Furniture</strong> (Бельгия, A. de Boecklaan 43, 1780 Wemmel, номер KBO/BTW: <strong>BE1024640395</strong>).
            </p>
            <p><strong>Наши международные офисы и партнеры:</strong></p>
            <ul className="list-disc pl-5 space-y-1 text-sm">
              <li><strong>Румыния (Официальное юридическое лицо):</strong> FEDYK FURNITURE S.R.L., Splaiul Independenței Nr. 313B, Et. 8, Ap. 135, Sector 6, București (VAT: RO52973961)</li>
              <li><strong>Ирландия (Логистический партнер и представитель):</strong> Deise Shipping Limited, 43 Heather Drive, Rathfarnham, Dublin 16, D16EK09 (VAT: IE9702158E)</li>
            </ul>
            <p>
              Обработка персональных данных осуществляется в строгом соответствии с Европейским Регламентом по защите данных (GDPR / AVG — EU 2016/679) и бельгийским Законом от 30 июля 2018 года.
            </p>
            <p>
              Ответственный за обработку данных: <strong>Oksana Fedyk</strong> (<a href="mailto:oksana@fedykfurniture.com" className="underline">oksana@fedykfurniture.com</a>, +32 495 56 22 55).
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-medium">2. Какие данные мы собираем и с какой целью</h2>
            <p>Мы собираем только те данные, которые необходимы для выполнения заказов и обслуживания:</p>
            <ul className="list-disc pl-5 space-y-2">
              <li><strong>Переписка и заявки:</strong> Имя, e-mail, телефон, текст обращения (хранятся до 2 лет).</li>
              <li><strong>Заказы и спецификации:</strong> Имя, адрес доставки, параметры проекта, платежные реквизиты (хранятся 10 лет согласно бельгийскому законодательству).</li>
              <li><strong>Инвойсы и финансовый учет:</strong> Имя, адрес, номер BTW/VAT, история платежей (хранятся 7–10 лет согласно налоговым нормам Бельгии).</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-medium">3. Ваши права (GDPR)</h2>
            <p>
              Вы имеете право запросить доступ к своим данным, их исправление, ограничение обработки или полное удаление («право на забвение»). Для реализации прав напишите нам: <a href="mailto:oksana@fedykfurniture.com" className="underline">oksana@fedykfurniture.com</a>.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-medium">4. Надзорный орган Бельгии</h2>
            <p>
              Вы имеете право подать жалобу в Бельгийский орган по защите данных:
              <br />
              <strong>Gegevensbeschermingsautoriteit (GBA) / APD</strong><br />
              Drukpersstraat 35, 1000 Brussel<br />
              Сайт: <a href="https://www.gegevensbeschermingsautoriteit.be" target="_blank" rel="noreferrer" className="underline">www.gegevensbeschermingsautoriteit.be</a>
            </p>
          </section>
        </article>
      )}

      {/* НИДЕРЛАНДСКИЙ ЯЗЫК */}
      {language === 'nl' && (
        <article className="prose dark:prose-invert max-w-none space-y-6">
          <h1 className="text-3xl font-light uppercase tracking-tight">PRIVACYBELEID</h1>
          <p className="text-sm text-muted-foreground">Laatst bijgewerkt: 12 augustus 2026</p>

          <section className="space-y-3">
            <h2 className="text-xl font-medium">1. Wie we zijn</h2>
            <p>
              Deze website wordt beheerd door de eenmanszaak van <strong>Oksana Fedyk</strong>, handelend onder de commerciële naam <strong>FEDYK Furniture</strong> (A. de Boecklaan 43, 1780 Wemmel, België, KBO/BTW: <strong>BE1024640395</strong>).
            </p>
            <p><strong>Onze internationale vestigingen en partners:</strong></p>
            <ul className="list-disc pl-5 space-y-1 text-sm">
              <li><strong>Roemenië (Dochteronderneming):</strong> FEDYK FURNITURE S.R.L., Spl. Independenței nr. 313B, Et. 8, Ap. 135, Sector 6, Boekarest (BTW: RO52973961)</li>
              <li><strong>Ierland (Logistieke partner & vertegenwoordiging):</strong> Deise Shipping Limited, 43 Heather Drive, Rathfarnham, Dublin 16, D16EK09 (BTW: IE9702158E)</li>
            </ul>
            <p>
              Elke verwerking van persoonsgegevens gebeurt conform de Europese Verordening Gegevensbescherming (GDPR/AVG - Verordening EU 2016/679) en de Belgische Wet van 30 juli 2018.
            </p>
            <p>
              Verantwoordelijke voor verwerking: <strong>Oksana Fedyk</strong> (<a href="mailto:oksana@fedykfurniture.com" className="underline">oksana@fedykfurniture.com</a>, +32 495 56 22 55).
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-medium">2. Welke persoonsgegevens verwerken wij?</h2>
            <ul className="list-disc pl-5 space-y-2">
              <li><strong>Contact & Correspondentie:</strong> Naam, e-mailadres, telefoonnummer, inhoud van het bericht.</li>
              <li><strong>Offertes & Bestellingen:</strong> Naam, adres, projectdetails, afmetingen meubilair.</li>
              <li><strong>Facturatie:</strong> Naam, adres, BTW-nummer, betalingsoverzicht (bewaartermijn 7-10 jaar conform Belgische wetgeving).</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-medium">3. Jouw rechten onder de AVG/GDPR</h2>
            <p>Je hebt recht op inzage, correctie, verwijdering en beperking van verwerking. Neem hiervoor contact op via <a href="mailto:oksana@fedykfurniture.com" className="underline">oksana@fedykfurniture.com</a>.</p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-medium">4. Gegevensbeschermingsautoriteit (GBA)</h2>
            <p>
              <strong>Gegevensbeschermingsautoriteit</strong><br />
              Drukpersstraat 35, 1000 Brussel<br />
              Website: <a href="https://www.gegevensbeschermingsautoriteit.be" target="_blank" rel="noreferrer" className="underline">www.gegevensbeschermingsautoriteit.be</a>
            </p>
          </section>
        </article>
      )}

      {/* АНГЛИЙСКИЙ ЯЗЫК */}
      {language === 'en' && (
        <article className="prose dark:prose-invert max-w-none space-y-6">
          <h1 className="text-3xl font-light uppercase tracking-tight">PRIVACY POLICY</h1>
          <p className="text-sm text-muted-foreground">Last updated: August 12, 2026</p>

          <section className="space-y-3">
            <h2 className="text-xl font-medium">1. Who We Are</h2>
            <p>
              This website is operated by <strong>Oksana Fedyk</strong> (Self-employed), operating under the trade name <strong>FEDYK Furniture</strong> (A. de Boecklaan 43, 1780 Wemmel, Belgium, VAT/KBO: <strong>BE1024640395</strong>).
            </p>
            <p><strong>International Entities & Partners:</strong></p>
            <ul className="list-disc pl-5 space-y-1 text-sm">
              <li><strong>Romania (Subsidiary):</strong> FEDYK FURNITURE S.R.L., Splaiul Independenței Nr. 313B, Fl. 8, Apt. 135, Sector 6, Bucharest (VAT: RO52973961)</li>
              <li><strong>Ireland (Logistics & Representative):</strong> Deise Shipping Limited, 43 Heather Drive, Rathfarnham, Dublin 16, D16EK09 (VAT: IE9702158E)</li>
            </ul>
            <p>
              We process personal data in compliance with the General Data Protection Regulation (GDPR - EU 2016/679) and the Belgian Act of July 30, 2018.
            </p>
            <p>
              Data Controller Contact: <strong>Oksana Fedyk</strong> (<a href="mailto:oksana@fedykfurniture.com" className="underline">oksana@fedykfurniture.com</a>, +32 495 56 22 55).
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-medium">2. Data We Collect and Purpose</h2>
            <ul className="list-disc pl-5 space-y-2">
              <li><strong>Inquiries & Contact:</strong> Name, e-mail, phone number, message content.</li>
              <li><strong>Orders & Custom Projects:</strong> Name, delivery address, project specifications. Kept for 10 years per Belgian accounting laws.</li>
              <li><strong>Invoicing:</strong> Name, address, VAT number, payment history. Kept for 7–10 years per Belgian tax law.</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-medium">3. Your GDPR Rights</h2>
            <p>You have the right to access, rectify, delete, and restrict the processing of your personal data. Contact us at <a href="mailto:oksana@fedykfurniture.com" className="underline">oksana@fedykfurniture.com</a>.</p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-medium">4. Supervisory Authority</h2>
            <p>
              <strong>Belgian Data Protection Authority (GBA/APD)</strong><br />
              Rue de la Presse 35, 1000 Brussels<br />
              Website: <a href="https://www.gegevensbeschermingsautoriteit.be" target="_blank" rel="noreferrer" className="underline">www.gegevensbeschermingsautoriteit.be</a>
            </p>
          </section>
        </article>
      )}

      {/* РУМЫНСКИЙ ЯЗЫК */}
      {language === 'ro' && (
        <article className="prose dark:prose-invert max-w-none space-y-6">
          <h1 className="text-3xl font-light uppercase tracking-tight">POLITICA DE CONFIDENȚIALITATE</h1>
          <p className="text-sm text-muted-foreground">Ultima actualizare: 12 august 2026</p>

          <section className="space-y-3">
            <h2 className="text-xl font-medium">1. Cine suntem</h2>
            <p>
              Acest site este operat de întreprinderea individuală <strong>Oksana Fedyk</strong>, desfășurând activitate sub denumirea comercială <strong>FEDYK Furniture</strong> (A. de Boecklaan 43, 1780 Wemmel, Belgia, CUI/CVA: <strong>BE1024640395</strong>).
            </p>
            <p><strong>Entități internaționale și reprezentanțe:</strong></p>
            <ul className="list-disc pl-5 space-y-1 text-sm">
              <li><strong>România (Filială):</strong> FEDYK FURNITURE S.R.L., Splaiul Independenței Nr. 313B, Et. 8, Ap. 135, Sector 6, București (CUI/CVA: RO52973961)</li>
              <li><strong>Irlanda (Partener logistic & Reprezentanță):</strong> Deise Shipping Limited, 43 Heather Drive, Rathfarnham, Dublin 16, D16EK09 (VAT: IE9702158E)</li>
            </ul>
            <p>
              Procesăm datele în conformitate cu Regulamentul General privind Protecția Datelor (GDPR - UE 2016/679) și Legea belgiană din 30 iulie 2018.
            </p>
            <p>
              Contact Coordonator: <strong>Oksana Fedyk</strong> (<a href="mailto:oksana@fedykfurniture.com" className="underline">oksana@fedykfurniture.com</a>, +32 495 56 22 55).
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-medium">2. Drepturile dumneavoastră GDPR</h2>
            <p>Aveți dreptul de acces, rectificare, ștergere și restricționare a datelor. Pentru exercitarea drepturilor, contactați-ne la <a href="mailto:oksana@fedykfurniture.com" className="underline">oksana@fedykfurniture.com</a>.</p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-medium">3. Autoritatea de Supraveghere</h2>
            <p>
              <strong>Autoritatea Belgiană pentru Protecția Datelor (GBA/APD)</strong><br />
              Rue de la Presse 35, 1000 Bruxelles<br />
              Website: <a href="https://www.gegevensbeschermingsautoriteit.be" target="_blank" rel="noreferrer" className="underline">www.gegevensbeschermingsautoriteit.be</a>
            </p>
          </section>
        </article>
      )}
    </div>
  );
};

export default PrivacyPage;
